module.exports = __webpack_public_path__ + "ba1b8056d93e72ec24ae56e0a9c3ede5.jpg";